<script>
  import { onMount } from 'svelte'
  import FaIcon from 'fa-svelte'
  import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
  import { Switch, Snackbar } from 'smelte'
  import Button from 'smelte/src/components/Button/Button.svelte'
  import Select from 'smelte/src/components/Select'
  import TextField from 'smelte/src/components/TextField'
  import { sparePartsAPI } from './api.js'
  import { writable } from 'svelte/store'
  import Cart from './Cart.svelte'
  import DetailsList from './DetailsList.svelte'
  import Metrics from '../Metrics.svelte'
  import { ProgressCircular } from 'smelte'
  import Dialog from 'smelte/src/components/Dialog/Dialog.svelte'


  export let params = {}
  export let baseInfo = {
    customerNo: '',
    customer: '',
    city: '',
    country: ''
  }
  export let productItems = []
  export let project = params.projectNo ? decodeURIComponent(params.projectNo) : '' // 'C034.00710'

  const api = new sparePartsAPI()
  let searchText = ''
  let filtered = writable([])

  $: searchFilter = searchText != null && searchText !== ''
    ? productItems
      .filter(p => (`${p.ProductNo} ${p.Description} + ${p.Name}`)
        .toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1)
    : productItems

  $: typeFilter = selectedProductType ? searchFilter.filter(p => p.MaterialType === selectedProductType) : searchFilter

  $: groupFilter = selectedProductGroup ? typeFilter.filter(p => p.ProductGroup === selectedProductGroup) : typeFilter

  $: $filtered = onlyWithSpareParts ? groupFilter
    .filter(p => p.SpCount > 0) : groupFilter
  //    .filter(p => p.SpCount > 0 || (p.Cfid != null && p.Cfid !== '')) : groupFilter

  let productGroups = []
  let productTypes = []

  let selectedProductGroup = null
  let selectedProductType = null
  let spareParts = []
  let onlyWithSpareParts = true
  let cartItemsList = writable([])
  let showCart = false

  let OLSCartId = null
  let errorSnackbar = {show: null, text: ''}
  let successSnackbar = {show: null, text: ''}
  let popup = {show: null, text: ''}

  let loadingPromise = loadData()

  $: inCartCount = $cartItemsList.reduce((sum, v) => sum + v.sparePart.quantity, 0) // spareParts.filter(s => s.value).length
  $: isCreateCartOLSEnabled = $cartItemsList.length < 1

  onMount(async () => {
    window.scrollTo(0, 0)
  })

  async function loadData () {
    api.getProductProps()
      .then(res => {
        if (res != null && res.data != null) {
          productGroups = ['', ...res.data.groups]
          productTypes = ['', ...res.data.types]
        }
      })
      .catch(err => {
        console.log('[ERROR] fetch product properties from settings', err)
      })

    let res = await api.getProducts(project)
    console.log('[DEBUG] api response', res)
    if (res.data != null && Array.isArray(res.data)) {
      productItems = res.data //.filter(onlyUnique)
    }

    res = await api.getProject(project)
    if (res.data) {
      baseInfo = {
        customerNo: res.data.CustomerNo.trim(),
        customer: res.data.eu_name,
        city: res.data.eu_city,
        country: res.data.eu_country,
        LinkedProject: res.data.LinkedProject
      }
      console.log('[DEBUG]', res)
    }

    // add products for linked project
    if (baseInfo.LinkedProject != null && baseInfo.LinkedProject.length > 0) {
      res = await api.getProducts(baseInfo.LinkedProject)
        .catch(err => {
          console.log('[DEBUG] getting products', err)
        })
      if (res.data != null && Array.isArray(res.data)) {
        productItems = [...productItems, ...res.data] //.filter(onlyUnique)
      }
    }

    // productItems.forEach((p, i) => { productItems[i].SumQty = 1 })

    return 1
  }

  function onlyUnique (value, index, self) {
    return self.findIndex(p => p.ProductNo === value.ProductNo) === index
  }

  function addToCartHandler ({detail}) {
    if (detail.value === true) {
      const item = {
        key: `${detail.parent}___${detail.SparePartNo}`,
        sparePart: detail
      }
      console.log('[DEBUG] item', item)
      $cartItemsList = [...$cartItemsList.filter(p => p.key !== item.key), item]
    }
    if (detail.value === false) {
      const key = `${detail.parent}___${detail.SparePartNo}`
      $cartItemsList = $cartItemsList.filter(p => p.key !== key)
    }
  }

  function createCartInOLS () {
    const list = $cartItemsList.map(p => ({productNumber: p.sparePart.SparePartNo, quantity: p.sparePart.quantity}))
    console.log('[DEBUG] create cart ini OLS', list)
    api.createCart(baseInfo.customerNo, {products: list})
      .then(res => {
        console.log('[DEBUG] create cart response:', res.data)
        OLSCartId = res.data
        // successSnackbar.text = `Cart ${res.data} created in Online Store.`
        // successSnackbar.show = true
        popup.text = `Cart ${res.data} created in Online Store.`
        popup.show = true
      })
      .catch(err => {
        errorSnackbar.text = `Can not create cart in Online Store. ${err}`
        errorSnackbar.show = true
      })
  }
</script>

<Metrics tag="/#/spare-part-list-generator" />

<div class="z-50">
  <Dialog bind:value={popup.show}>
    <div slot="title" class="select-none text-gray-700 uppercase w-full flex justify-end items-center btn"
         on:click={() => popup.show = false}>
      <i class="material-icons icon ml-2 close-icon">close</i>
    </div>

    <div class="text-xl text-gray-700 py-10 px-16">
      {popup.text}
    </div>
  </Dialog>
</div>

<div class="container mx-auto px-8 bg-white">
  <!-- header -->
  <div class="flex flex-wrap header bg-white border-b border-gray-400 z-30">

    <div class="w-full md:w-1/3 info text-left flex flex-col justify-center text-lg text-gray-500 xl:pl-20 pt-10">
      <div class="text-xl mb-3 text-black ">SPARE PART LIST GENERATOR</div>
      <div class="mb-8">BOM project number: {project}</div>
      <!--
      <div class="pb-1">INSTALLED BASE</div>
      -->
      <div class="pb-1">{baseInfo.customer}</div>
      <div class="pb-1">{baseInfo.city} {!!baseInfo.country ? ', ' + baseInfo.country : ''}</div>
      <!--
      <div class="pb-1">Installation date: {baseInfo.created}</div>
      -->
      <div class="mt-5 text-gray-50 text-base font-light">
        <Switch label="Show only items with spare parts associated"
                color="red"
                class="cart-switch"
                bind:value={onlyWithSpareParts} />
      </div>
    </div>

    <div class="w-full md:w-2/3 py-10">
      <div class="xl:w-3/4 mx-auto">
        <div class="text-right text-gray-500 font-light mb-10"> <!-- on:click={() => { showCart = true }}> -->
          <div class="flex justify-end">
            <div data-tracking="spare_parts.Create_cart_in_Online_Store">
              <Button remove="rounded"
                      add={"inline flex items-center " + (!isCreateCartOLSEnabled ? "elevation-3 hover:elevation-5 " : "")}
                      color="red" disabled={isCreateCartOLSEnabled}
                      on:click={createCartInOLS}
              >
                <div class="inline-block mr-3" style="margin-top: 0.15em">Create cart in Online Store</div>

                <FaIcon icon={faCartPlus} class="text-xl" />
              </Button>
            </div>
          </div>
          <div class="text-lg mt-3">{inCartCount} item(s)</div>
        </div>
        <TextField label="Enter your search term here ..."
                   append="search"
                   bind:value={searchText} />
        <div class="grid grid-cols-2 gap-6">
          <div class="">
            <Select label="Machine model / Product group"
                    listClasses="h-64 overflow-x-auto"
                    class="input-field"
                    items={productGroups}
                    bind:value={selectedProductGroup} />
          </div>
          <div class="">
            <Select class="input-field"
                    listClasses="h-64 overflow-x-auto"
                    label="Product Type"
                    items={productTypes}
                    bind:value={selectedProductType} />
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- details list -->
  {#await loadingPromise}
    <div class="mx-auto inline-block text-center pt-24 h-64">
      <ProgressCircular />
    </div>
  {:then result}
    <DetailsList {project} filtered={$filtered} bind:spareParts={spareParts}
                 on:add_to_cart={addToCartHandler}
    />
  {:catch error}
    <div class="py-20 text-gray-400 font-light">
      <span class="text-xl">
        Sorry, there is a data connectivity problem. Please contact support service
      </span>
      <div class="text-base pt-5">
        {error}
      </div>
    </div>
  {/await}

  <Cart bind:showCart={showCart} cartItemsList={$cartItemsList} />
</div>

<Snackbar color="alert" bottom bind:value={errorSnackbar.show}>
  <div>{errorSnackbar.text}</div>
</Snackbar>
<Snackbar color="success" bottom bind:value={successSnackbar.show}>
  <div>{successSnackbar.text}</div>
</Snackbar>


<style>
    .header {
        min-height: 300px;
    }

    .header .info {
        min-width: 200px;
    }

    :global(.select) {
        height: 3.2em;
    }

    :global(.cart-switch .bg-gray-700) {
        background-color: #cacaca !important;
    }

    :global(.cart) {
        font-size: 2em !important;
    }

    .btn:hover {
        cursor: pointer;
    }
</style>
